import { useQuery } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

// Define the structure for formula configuration
interface FormulaConfig {
    expression: string;
    outputFormat?: "WholeNumber" | "Decimal";
}

// Define the structure for subcategory-level formulas
interface SubcategoryFormulas {
    [subcategory: string]: FormulaConfig;
}

// Define the structure for product-level formulas, allowing both global and subcategory formulas
interface ProductFormula {
    expression?: string; // Optional global formula for the product
    outputFormat?: "WholeNumber" | "Decimal"; // Optional global format
    subcategories?: SubcategoryFormulas; // Subcategory-specific formulas
}

// Define the structure for formulas collection
export interface Formulas {
    [product: string]: ProductFormula;
}

export default function useFormulas() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useList() {
        return useQuery<Formulas>({
            queryKey: ["formulas"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/formulas/list");
                return parseSuccessResponseData(response) as Formulas;
            },
        });
    }

    return {
        useList,
    };
}
